<template>
    <v-toolbar-title>
        <v-btn text icon @click="prev">
            <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn text icon @click="next">
            <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
        {{this.displayDate | title}}
    </v-toolbar-title>
</template>

<script>
  import Controls from './MonthControls.vue';
  import moment from 'moment';

  export default {
    mixins: [
      Controls,
    ],
    filters: {
      title(date) {
        return moment(date).format('MMM YYYY');
      },
    },
  };
</script>
